<template>
  <v-dialog v-model="dialogVisible" max-width="580" persistent>
    <v-card class="lesson-form-card rounded-lg">
      <v-card-title class="form-header px-6 py-4">
        <span class="text-lg font-bold text-white">{{ isEdit ? 'Edit Lesson' : 'Add New Lesson' }}</span>
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-6">
        <v-form ref="lessonForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.title"
            label="Lesson Title"
            :rules="[v => !!v || 'Title is required']"
            outlined
            dense
            class="mb-1"
            prepend-inner-icon="mdi-play-circle-outline"
          />

          <v-textarea
            v-model="form.description"
            label="Description"
            :rules="[v => !!v || 'Description is required']"
            outlined
            dense
            rows="3"
            class="mb-1"
            prepend-inner-icon="mdi-text"
          />

          <v-text-field
            v-model="form.videoUrl"
            label="Video URL"
            outlined
            dense
            class="mb-1"
            prepend-inner-icon="mdi-video-outline"
            hint="Leave empty for default sample video"
            persistent-hint
          />

          <v-text-field
            v-model="form.duration"
            label="Duration (e.g., 15:30)"
            :rules="[v => !!v || 'Duration is required']"
            outlined
            dense
            prepend-inner-icon="mdi-clock-outline"
            placeholder="MM:SS"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-5">
        <v-spacer />
        <v-btn text class="mr-2 normal-case" @click="close">Cancel</v-btn>
        <v-btn
          color="#21427d"
          class="white--text normal-case px-6 rounded-lg"
          :disabled="!valid"
          @click="submit"
          depressed
        >
          <v-icon left small>{{ isEdit ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
          {{ isEdit ? 'Update' : 'Add Lesson' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LessonFormDialog',
  props: {
    value: { type: Boolean, default: false },
    editData: { type: Object, default: null }
  },
  data() {
    return {
      valid: false,
      form: {
        title: '',
        description: '',
        videoUrl: '',
        duration: ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    isEdit() {
      return !!this.editData
    }
  },
  watch: {
    value(val) {
      if (val && this.editData) {
        this.form = {
          title: this.editData.title || '',
          description: this.editData.description || '',
          videoUrl: this.editData.videoUrl || '',
          duration: this.editData.duration || ''
        }
      } else if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.form = { title: '', description: '', videoUrl: '', duration: '' }
      if (this.$refs.lessonForm) {
        this.$refs.lessonForm.resetValidation()
      }
    },
    submit() {
      if (this.$refs.lessonForm.validate()) {
        this.$emit('save', { ...this.form })
        this.close()
      }
    },
    close() {
      this.resetForm()
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.lesson-form-card {
  overflow: hidden;
}
.form-header {
  background: linear-gradient(135deg, #21427d 0%, #3a6bc5 100%);
}
</style>
